/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import history from 'helpers/history';
import { productPropTypes } from 'helpers/propTypes';
import { getFullUrl } from 'helpers/window';
import { formatCurrencyARS } from 'helpers/currency';
import { sendSuccessNotification } from 'helpers/notifications';
import { updateCart } from 'redux/actions/cart.actions';
import { getSingleQuote } from 'redux/actions/shipping.actions';
import { itemsQuantitySelector, itemsSubQuantitySelector } from 'redux/selectors/cart.selector';
import { productImagesSelector } from 'redux/selectors/product.selector';
import { openPaymentMethodsModal } from 'redux/actions/modal.actions';

import Product from 'views/Product';
import ProductTextil from 'views/Product/ProductTextil';

const ProductContainer = (props) => {
  const {
    images, item, onClose, isSinglePage, updateCartAction, cartItemDescriptions, cartItemSubDescriptions,onlyUsers,
    user, client, getSingleQuoteAction, singleQuote, zipCode, singleQuoteLoading,
    cuotasMP, openPaymentMethodsModalAction, showMPButton, envios, paymentMethods,
    autoDiscounts,
  } = props;
  const showShippingQuote = envios?.some((e) => e.calculated_by_system) ?? false;
  const singleProductUrl = `/producto/${encodeURIComponent(item.code)}`;
  const singleProductFullUrl = getFullUrl(singleProductUrl);
  const [wholesale, setWholesale] = useState({ id: 0, bool: false, quantity: 0, curva: false });
  const productCart = cartItemDescriptions?.find(
    (data) => ((data.wholesale?.bool === wholesale.bool) && (data?.wholesale?.id === wholesale.id)),
  );
  const productCartSub = cartItemSubDescriptions?.find(
    (data) => ((data.wholesale?.bool === wholesale.bool) && (data.wholesale?.id === wholesale.id)),
  );
  const colors = item?.stock_product_descriptions?.filter(
    ({ stock_descriptions }) => stock_descriptions.stock_category_id === 1,
  );
  const talles = item?.stock_product_descriptions?.filter(
    ({ stock_descriptions }) => stock_descriptions.stock_category_id === 2,
  );

  const combinations = colors?.reduce((a, b) => {
    a[b.stock_description_id] = a[b.stock_description_id] || [];
    const combination = item?.stock_product_descriptions
      ?.filter(({ stock_descriptions }) => stock_descriptions.stock_category_id !== 1)
      ?.find(
        (stock_product_description) => stock_product_description.combination === b.combination,
      );
    if (combination) a[b.stock_description_id].push(combination);
    return a;
  }, Object.create(null));

  const combinationsTalle = talles?.reduce((a, b) => {
    a[b.stock_description_id] = a[b.stock_description_id] || [];
    const combinationTalle = item?.stock_product_descriptions
      ?.filter(({ stock_descriptions }) => stock_descriptions.stock_category_id !== 2)
      ?.find(
        (stock_product_description) => stock_product_description.combination === b.combination,
      );
    if (combinationTalle) a[b.stock_description_id].push(combinationTalle);
    return a;
  }, Object.create(null));

  const [selectedColor, setSelectedColor] = useState(null);
  const [imagesColor, setImagesColor] = useState([]);
  const productImages = images?.length ? images : (client?.image ? [client.image] : []);

  const handleColorSelect = (color) => {
    setSelectedColor(color.stock_description_id);
    const imagesDescription = [color.image_1, color.image_2, ...(images || [])].filter(Boolean);
    const uniqueImages = [...new Set(imagesDescription)];
    setImagesColor(uniqueImages);
  };

  const onProductClick = () => {
    onClose();
    history.push(singleProductUrl);
  };

  const onProductCopyClick = () => {
    sendSuccessNotification('Link del producto copiado con éxito');
  };

  const onQuantityChange = (value, description) => {
    const usaMetros = item?.usoMetros || false;
    if(client?.design === 3 && usaMetros) {
      updateCartAction(item.id, value, null, wholesale ,null);
    }
    else if (description) {
      updateCartAction(item.id, value, description.id, wholesale,description.stock_descriptions.name);
    } else {
      updateCartAction(item.id, value, null, wholesale,null);
    }
  };

  const getValidPriceRange = () => {
    const validPrices = talles.filter((talle) => talle.price !== null && talle.price > 0).map((talle) => talle.price);
    const distinctPrices = Array.from(new Set(validPrices));
    if (distinctPrices.length === 1) {
      return formatCurrencyARS(validPrices[0]);
    }
    const minPrice = Math.min(...distinctPrices);
    const maxPrice = Math.max(...distinctPrices);
    return `${formatCurrencyARS(minPrice)} - ${formatCurrencyARS(maxPrice)}`;
  };

  const currentQuantity = productCart ? productCart.quantity : (productCartSub?.quantity || 1);

  const getUnitPrice = () => {
    if (item.price && item.price > 0) return item.price;
    if (talles && talles.length > 0) {
        const validPrices = talles.filter(t => t.price > 0).map(t => t.price);
        if (validPrices.length > 0) return Math.min(...validPrices);
    }
    return 0;
  };

  const unitPrice = getUnitPrice();
  const numericTotal = unitPrice * currentQuantity;

  const discountCases = [];
    if (autoDiscounts.length > 0 && paymentMethods?.length > 0) {
      autoDiscounts.forEach(tier => {
        paymentMethods.forEach(pm => {
          if (pm.allow_discount && pm.percent > 0) {
            const totalCombinedOff = Math.round((1 - (1 - tier.percentage / 100) * (1 - pm.percent)) * 100);
            discountCases.push({
              min: tier.amount,
              totalOff: totalCombinedOff,
              pmName: pm.name
            });
          }
        });
      });
    }
    
  const bestPromo = (paymentMethods || []).reduce((acc, pm) => {
    let price = unitPrice;
    if (pm.allow_discount && autoDiscounts.length > 0) {
      const tier = [...autoDiscounts].filter(t => unitPrice >= t.amount).sort((a, b) => b.amount - a.amount)[0];
      if (tier) price *= (1 - tier.percentage / 100);
    }
    const final = price * (1 - (pm.percent || 0));
    const off = Math.round((1 - final / unitPrice) * 100);
    
    if (!acc || final < acc.final) return { final, name: pm.name, off };
    return acc;
  }, null);

  const handleOpenPaymentModal = () => {
    openPaymentMethodsModalAction(cuotasMP, numericTotal);
  };

  let marginStyle = '';
  switch (client?.design) {
    case 4:
      marginStyle = 'neo';
      break;
    case 5:
      marginStyle = 'd5';
      break;
    case 7:
      marginStyle = 'd7';
      break;
    case 6:
      marginStyle = 'man';
      break;
    default:
      marginStyle = '';
  }

  switch(client?.design) {
    case 3:
      if(item?.usoMetros){
        return(
          <ProductTextil
          images={selectedColor && imagesColor.length ? imagesColor : productImages}
          selectedColor={selectedColor}
          handleColorSelect={handleColorSelect}
          item={item}
          onProductClick={onProductClick}
          onProductCopyClick={onProductCopyClick}
          onQuantityChange={onQuantityChange}
          productCart={productCart}
          productCartSub={productCartSub}
          cartItemDescriptions={cartItemDescriptions}
          cartItemSubDescriptions={cartItemSubDescriptions}
          singleProductFullUrl={singleProductFullUrl}
          colors={colors}
          wholesale={wholesale}
          setWholesale={setWholesale}
          combinations={combinations}
          talles={talles}
          combinationsTalle={combinationsTalle}
          getValidPriceRange={getValidPriceRange}
          show={onlyUsers == false || (onlyUsers == true && !!user)}
          onClose={onClose}
          getSingleQuoteAction={getSingleQuoteAction}
          singleQuote={singleQuote}
          zipCode={zipCode}
          singleQuoteLoading={singleQuoteLoading}
          onOpenPaymentModal= {handleOpenPaymentModal}
          cuotasMP={cuotasMP}
          showMPButton={showMPButton}
          showShippingQuote={showShippingQuote}
          paymentMethods={paymentMethods}
          autoDiscounts={autoDiscounts}
          />
        )
      }else{
        return (
          <Product
            isSinglePage={isSinglePage}
            images={selectedColor && imagesColor.length ? imagesColor : productImages}
            selectedColor={selectedColor}
            handleColorSelect={handleColorSelect}
            item={item}
            onProductClick={onProductClick}
            onProductCopyClick={onProductCopyClick}
            onQuantityChange={onQuantityChange}
            productCart={productCart}
            productCartSub={productCartSub}
            cartItemDescriptions={cartItemDescriptions}
            cartItemSubDescriptions={cartItemSubDescriptions}
            singleProductFullUrl={singleProductFullUrl}
            colors={colors}
            wholesale={wholesale}
            setWholesale={setWholesale}
            combinations={combinations}
            talles={talles}
            combinationsTalle={combinationsTalle}
            getValidPriceRange={getValidPriceRange}
            show={onlyUsers == false || (onlyUsers == true && !!user)}
            onClose={onClose}
            getSingleQuoteAction={getSingleQuoteAction}
            singleQuote={singleQuote}
            zipCode={zipCode}
            singleQuoteLoading={singleQuoteLoading}
            onOpenPaymentModal= {handleOpenPaymentModal}
            cuotasMP={cuotasMP}
            showMPButton={showMPButton}
            showShippingQuote={showShippingQuote}
            autoDiscounts={autoDiscounts}
            paymentMethods={paymentMethods}
          />
        )
      }

    default:
      return (
        <div className={`product-modal ${marginStyle}`}>
          <Product
            isSinglePage={isSinglePage}
            images={selectedColor && imagesColor.length ? imagesColor : productImages}
            selectedColor={selectedColor}
            handleColorSelect={handleColorSelect}
            item={item}
            onProductClick={onProductClick}
            onProductCopyClick={onProductCopyClick}
            onQuantityChange={onQuantityChange}
            productCart={productCart}
            productCartSub={productCartSub}
            cartItemDescriptions={cartItemDescriptions}
            cartItemSubDescriptions={cartItemSubDescriptions}
            singleProductFullUrl={singleProductFullUrl}
            colors={colors}
            wholesale={wholesale}
            setWholesale={setWholesale}
            combinations={combinations}
            talles={talles}
            combinationsTalle={combinationsTalle}
            getValidPriceRange={getValidPriceRange}
            show={onlyUsers == false || (onlyUsers == true && !!user)}
            onClose={onClose}
            getSingleQuoteAction={getSingleQuoteAction}
            singleQuote={singleQuote}
            zipCode={zipCode}
            singleQuoteLoading={singleQuoteLoading}
            onOpenPaymentModal= {handleOpenPaymentModal}
            cuotasMP={cuotasMP}
            showMPButton={showMPButton}
            showShippingQuote={showShippingQuote}
            autoDiscounts={autoDiscounts}
            unitPrice={unitPrice}
            paymentMethods={paymentMethods}
          />
        </div>
      )
  }
};

const mapStateToProps = (state, props) => ({
  images: productImagesSelector(state, props),
  cartItemDescriptions: itemsQuantitySelector(state, props),
  cartItemSubDescriptions: itemsSubQuantitySelector(state, props),
  user: state.user.data,
  onlyUsers: state.app.onlyUsers,
  client: state.app.client,
  envios: state.app.envios,
  singleQuote: state.shipping.singleQuote,
  zipCode: state.shipping.zipCode,
  singleQuoteLoading: state.shipping.loading,
  cuotasMP: state.app.cuotasMP,
  showMPButton: state.app.showMPButton,
  paymentMethods: state.app.paymentMethods,
  autoDiscounts: state.app.discount
});

const mapDispatchToProps = (dispatch) => ({
  updateCartAction: bindActionCreators(updateCart, dispatch),
  getSingleQuoteAction: bindActionCreators(getSingleQuote, dispatch),
  openPaymentMethodsModalAction: bindActionCreators(openPaymentMethodsModal, dispatch),
});

ProductContainer.defaultProps = {
  cartItemDescriptions: null,
  cartItemSubDescriptions: null,
  onClose: () => { },
  singleQuote: null,
  zipCode: '',
  singleQuoteLoading: false,
  isSinglePage: false,
};

ProductContainer.propTypes = {
  cartItemDescriptions: PropTypes.arrayOf(PropTypes.shape({
    descriptionId: PropTypes.number,
  })),
  cartItemSubDescriptions: PropTypes.arrayOf(PropTypes.shape({
    descriptionId: PropTypes.number,
  })),
  item: productPropTypes.isRequired,
  isSinglePage: PropTypes.bool,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClose: PropTypes.func,
  updateCartAction: PropTypes.func.isRequired,
  getSingleQuoteAction: PropTypes.func.isRequired,
  singleQuote: PropTypes.object,
  zipCode: PropTypes.string,
  singleQuoteLoading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductContainer);
